import React from 'react';
import styles from "./SalonEndTimeStep.module.scss";
import CustomTimePicker from "../../customComponents/CustomTimePicker";
import {authActions} from "../../../../../store";
import {useDispatch, useSelector} from "react-redux";
import {salonWorkTimes} from "../../../../../store/selectors";
import {SalonWorkTimeStepWrapper} from "../SalonWorkTimeStepWrapper";

export const SalonEndTimeStepContainer = () => {
  const dispatch = useDispatch();
  const {startMorning, startEvening, endEvening} = useSelector(salonWorkTimes());

  const setValue = (endEvening) => {
    dispatch(authActions.SET_SALON_WORK_TIMES.SUCCESS({endEvening}))
  }

  return (
    <SalonWorkTimeStepWrapper
      title={'A che ora chiudi il tuo salone?'}
      actionDisabled={!endEvening}
      action={() => dispatch(authActions.GET_ACTIVE_SIGN_UP_STEP.SUCCESS(7))}
    >
      <div className={styles.salon_picker}>
        <CustomTimePicker
          title={'Imposta l’orario di chiusura del salone'}
          value={endEvening}
          setValue={setValue}
          minTime={startEvening || startMorning}
        />
      </div>
    </SalonWorkTimeStepWrapper>
  )
}
